  
// NATIVE MODULES

import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

// COMPONENTS
import { NgLetDirective } from './ng-let.directive';

@NgModule({
  declarations: [
    NgLetDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports : [
    NgLetDirective
  ],
  providers: [
  ],
  entryComponents: [

  ]
})
export class SuperDirectivesModule { }
